/** SNS DT Playbook — step → page (mirrors backend utils/dtPlaybookStructure.js). */
export const DT_PLAYBOOK_STEPS = [
  { week: 1, stage: "Empathize & Define", step: "Problem Identification", page: 8 },
  { week: 1, stage: "Empathize & Define", step: "Similar Products", page: 10 },
  { week: 1, stage: "Empathize & Define", step: "My Ideas", page: 12 },
  { week: 1, stage: "Empathize & Define", step: "Audience", page: 14 },
  { week: 1, stage: "Empathize & Define", step: "Focus", page: 16 },
  { week: 1, stage: "Empathize & Define", step: "Tech Stack Suggestions", page: 17 },
  { week: 1, stage: "Empathize & Define", step: "Empathy Map", page: 18 },
  { week: 1, stage: "Empathize & Define", step: "Process Flow", page: 20 },
  { week: 1, stage: "Empathize & Define", step: "Pitch Among Peers", page: 22 },
  { week: 2, stage: "Plan", step: "User Actions", page: 24 },
  { week: 2, stage: "Plan", step: "App State", page: 26 },
  { week: 2, stage: "Plan", step: "Features", page: 28 },
  { week: 2, stage: "Plan", step: "Inclusion", page: 30 },
  { week: 2, stage: "Plan", step: "UI/UX", page: 32 },
  { week: 3, stage: "Prototype", step: "Sketch Screens", page: 34 },
  { week: 3, stage: "Prototype", step: "Storyboard", page: 36 },
  { week: 3, stage: "Prototype", step: "Refine Behaviour", page: 38 },
  { week: 3, stage: "Prototype", step: "Design Style", page: 40 },
  { week: 3, stage: "Prototype", step: "Build in Figma", page: 42 },
  { week: 3, stage: "Prototype", step: "MVC", page: 44 },
  { week: 4, stage: "Evaluate", step: "App Pitch", page: 46 },
  { week: 4, stage: "Evaluate", step: "Prepare Test", page: 48 },
  { week: 4, stage: "Evaluate", step: "Observation", page: 50 },
  { week: 4, stage: "Evaluate", step: "Interview", page: 52 },
  { week: 4, stage: "Evaluate", step: "Reiterate", page: 54 },
  { week: 5, stage: "Pitch & BMC", step: "BMC Canvas", page: 56 },
  { week: 5, stage: "Pitch & BMC", step: "Customer Sales Pitch", page: 58 },
  { week: 5, stage: "Pitch & BMC", step: "Final Pitch Deck", page: 60 },
];

const norm = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

/** Match a DT step from "Step:" text (exact, then contains). */
export function dtStepByName(name = "") {
  const n = norm(name).replace(/^step \d+\s*/, "");
  if (!n) return null;
  return (
    DT_PLAYBOOK_STEPS.find((s) => norm(s.step) === n) ||
    DT_PLAYBOOK_STEPS.find((s) => n.includes(norm(s.step))) ||
    DT_PLAYBOOK_STEPS.find((s) => norm(s.step).includes(n) && n.length >= 4) ||
    null
  );
}

export function dtStepByPage(page) {
  const p = Number(page);
  if (!Number.isFinite(p)) return null;
  return DT_PLAYBOOK_STEPS.find((s) => s.page === p) || null;
}

/** Fallback walk: Nth working day of the plan → Nth playbook step. */
export function dtStepByDayIndex(dayIdx = 0) {
  const i = Math.max(0, Number(dayIdx) || 0);
  return DT_PLAYBOOK_STEPS[Math.min(i, DT_PLAYBOOK_STEPS.length - 1)] || null;
}

/** Find the DT step a cell / day refers to: explicit page → Step: label → day order. */
export function resolveDtStep(text = "", dayIdx = null) {
  const t = String(text || "").replace(/\\n/g, "\n");
  const pageHit = t.match(/DT\s*Playbook\s*page\s*(\d{1,3})/i);
  if (pageHit) {
    const s = dtStepByPage(pageHit[1]);
    if (s) return s;
    return { stage: "", step: "", page: Number(pageHit[1]) };
  }
  const stepHit = t.match(/(?:^|\n)\s*(?:▶\s*)?(?:Step|DT Step|Playbook Step)\s*:\s*([^\n·|]+)/i);
  if (stepHit) {
    const s = dtStepByName(stepHit[1]);
    if (s) return s;
  }
  for (const s of DT_PLAYBOOK_STEPS) {
    if (new RegExp(`["“]${s.step.replace(/[.*+?^${}()|[\]\\/]/g, "\\$&")}["”]`, "i").test(t)) return s;
  }
  return dayIdx == null ? null : dtStepByDayIndex(dayIdx);
}

export function dtPageLine(step) {
  if (!step?.page) return "";
  const name = step.step ? ` — "${step.step}"` : "";
  const stage = step.stage ? ` · ${step.stage}` : "";
  return `▶ DT Playbook page ${step.page}${name}${stage} — take and fill the questions on this page`;
}
